export const ComponentsTableColumns = [
    {
        displayName: 'Component',
        sortColumnName: 'name',
        dataType: 'string',
        dataKey: 'name',
        settings: { sort: true, filter: false, multiple: false },
        css: 'w-75 text-left',
    },
    {
        displayName: 'Principle',
        sortColumnName: 'principle',
        dataType: 'string',
        dataKey: 'principle',
        settings: { sort: true, filter: false, multiple: false },
        css: 'w-25 pad-end',
    },
];

export const ComponentsSortingConfig = {
    sortByColumn: 'name',
    sortByDescending: false,
    callback: () => {},
};

export const ComponentsPaginationConfig = {
    paginationEvent: () => {},
    paginationData: {
        pageNumber: 1,
        pageSize: 5,
        total: 0,
    },
    defaultPageSize: {
        value: 5,
        text: '5',
    },
};
